import { AutomationEventTypes } from '@tokeet-frontend/automations'

export const userCardNotificationMessages = {
  [AutomationEventTypes.PaymentCardAccepted]: {
    subject: 'Credit Card Accepted – *|GUEST:NAME|*',
    message: `
      Hi Team,

      The guest's credit card has been successfully accepted. Please update the records accordingly.

      Booking Details:
      Guest Name: *|GUEST:NAME|*
      Check-in/Check-out: *|INQUIRY:ARRIVE|* to *|INQUIRY:DEPART|*
      Guests: *|INQUIRY:ADULTS|* Adults, *|INQUIRY:CHILDREN|* Children
      `,
  },
  [AutomationEventTypes.PaymentCardDeclined]: {
    subject: 'Credit Card Declined – *|GUEST:NAME|*',
    message: `
      Hi Team,

      The guest's credit card was declined. Please follow up with the guest to resolve the issue.

      Booking Details:
      Guest Name: *|GUEST:NAME|*
      Check-in/Check-out: *|INQUIRY:ARRIVE|* to *|INQUIRY:DEPART|*
      Guests: *|INQUIRY:ADULTS|* Adults, *|INQUIRY:CHILDREN|* Children
    `,
  },
  [AutomationEventTypes.PaymentCardRejected]: {
    subject: 'Credit Card Rejected – *|GUEST:NAME|*',
    message: `
      Hi Team,

      The guest's credit card was rejected. Please follow up with the guest to resolve the issue.

      Booking Details:
      Guest Name: *|GUEST:NAME|*
      Check-in/Check-out: *|INQUIRY:ARRIVE|* to *|INQUIRY:DEPART|*
      Guests: *|INQUIRY:ADULTS|* Adults, *|INQUIRY:CHILDREN|* Children
      `,
  },
  [AutomationEventTypes.PaymentCardDeleted]: {
    subject: 'Credit Card Deleted – *|GUEST:NAME|*',
    message: `
      Hi Team,

      Please note that the guest's credit card has been successfully deleted. Update the records accordingly.

      Booking Details:
      Guest Name: *|GUEST:NAME|*
      Check-in/Check-out: *|INQUIRY:ARRIVE|* to *|INQUIRY:DEPART|*
      Guests: *|INQUIRY:ADULTS|* Adults, *|INQUIRY:CHILDREN|* Children
      `,
  },
}

export const guestCardNotificationMessages = {
  [AutomationEventTypes.PaymentCardAccepted]: {
    subject: 'Payment Method Accepted – *|RENTAL:NAME|*',
    message: `
      Dear *|GUEST:NAME|*,

      We’re pleased to inform you that your credit card has been successfully accepted for your booking at *|RENTAL:NAME|*.

      If you have any questions or need further assistance, please don't hesitate to contact us at *|RENTAL:PHONE|*.
    `,
  },
}
